import { ESTIMATE_ROUTES } from '../../../config/api-routes';
import instance from '../../../config/instance';
import { paramsToQueryString } from '../../../utility/helpers/commonFunction';

export const generateEstimateNumberApi = async () => {
    const response = await instance.get(ESTIMATE_ROUTES.GENERATE_ESTIMATE_NUMBER);
    return response?.data?.data;
};

export const estimateListApi = async (params) => {
    const queryParams = paramsToQueryString(params);
    const response = await instance.get(ESTIMATE_ROUTES.ESTIMATE_LIST + queryParams);
    return response?.data?.data;
};

/**
 * GET — the open estimate draft for a vehicle: `{ vehicleId }`.
 * → the draft record, or null when there is none.
 */
export const findOpenEstimateDraftApi = async (params) => {
    const response = await instance.get(ESTIMATE_ROUTES.FIND_OPEN_DRAFT, { params });
    const data = response?.data?.data;
    return data?.exists ? data.draft || null : null;
};
